import { render, staticRenderFns } from "./GPaymentStatusChip.vue?vue&type=template&id=72effbfc&scoped=true"
import script from "./GPaymentStatusChip.vue?vue&type=script&lang=js"
export * from "./GPaymentStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72effbfc",
  null
  
)

export default component.exports